module.exports = __webpack_public_path__ + "img/featured.19d11e8d.svg";